import React from 'react';
import CategoryTemplate from 'templates/category';
import { useTranslation } from 'react-i18next';
import { useStaticQuery, graphql } from 'gatsby';

const CategoryPage = () => {
  const [t] = useTranslation();
  const image = useStaticQuery(graphql`
    query {
      strapiCategory(slug: { eq: "barnvakt" }) {
        image {
          childImageSharp {
            fluid(maxHeight: 1024, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `);

  return (
    <CategoryTemplate
      heading={t('page--babysitting.heading')}
      subheading={t('page--babysitting.subheading')}
      buttonLabel={t('page--babysitting.buttonLabel')}
      content={t('page--babysitting.content')}
      image={image.strapiCategory.image}
      ctaTitle={t('page--babysitting.ctaTitle')}
      seoTitle={t('page--babysitting.seoTitle')}
      seoDescription={t('page--babysitting.seoDescription')}
    />
  );
};
export default CategoryPage;
